
import './App.css'
import Quiz from 'components/quiz'
import 'bootstrap/dist/css/bootstrap.min.css'

function App({ quiz_type }: any) {
  return (
    <div style={{ height: '100vh' }}>
      <div className="row h-100">
        <div className="col-12 h-100">
          <Quiz quiz_type={quiz_type} />
        </div>
      </div>
    </div>
  );
}

export default App;
